import React from "react"
import { innerPageIframeStyle, fullPageIframeStyle } from "./styles"
import { useTranslation } from "react-i18next"

export const PrivacyPolicyInner: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/privacy-policy.html"
                title={t("Privacy Policy")}></iframe>
        </div>
    )
}

export const EULAInner: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/EULA.html"
                title={t("End User License Agreement")}></iframe>
        </div>
    )
}

export const DisclaimerInner: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/disclaimer.html"
                title={t("Disclaimer")}></iframe>
        </div>
    )
}

export const TermsOfUseInner: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/terms-of-use.html"
                title={t("Terms of Use")}></iframe>
        </div>
    )
}

export const TermsOfUsePage: React.FC = () => {
    const { t } = useTranslation()
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/terms-of-use.html"
                title={t("Terms of Use")}></iframe>
    )
}

export const PrivacyPolicyPage: React.FC = () => {
    const { t } = useTranslation()
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/privacy-policy.html"
            title={t("Privacy Policy")}></iframe>
    )
}

export const DisclaimerPage: React.FC = () => {
    const { t } = useTranslation()
    return (
        <iframe style={fullPageIframeStyle} src="https://aidocr.com/legal/disclaimer.html" title={t("Disclaimer")}></iframe>
    )
}

export const EULAPage: React.FC = () => {
    const { t } = useTranslation()
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/EULA.html"
            title={t("End User License Agreement")}></iframe>
    )
}
